import { useGetTransactionsQuery } from '../api';
import { transactionTransformer } from '../helpers';

export function useTransactionsView() {
  const { data: transactions } = useGetTransactionsQuery();
  return transactions?.map(transactionTransformer).sort((a, b) => b.date.getTime() - a.date.getTime());
}
